import React from 'react';

import './BackgroundLayer.scss';

export default function BackgroundLayer() {
  return <div className="bglayer"></div>;
}
